import {CallToAction} from '@contentlab/api/avatars/types';

export const CUSTOM_GOAL_VALUE = 'other' as const;

export interface GoalOption {
  id: CallToAction | typeof CUSTOM_GOAL_VALUE;
  localeLabelKey: string;
}

export const GOAL_OPTIONS: GoalOption[] = [
  {id: CallToAction.BuyNow, localeLabelKey: 'Buy now'},
  {id: CallToAction.GetStarted, localeLabelKey: 'Get started'},
  {id: CallToAction.BuildBuzz, localeLabelKey: 'Build buzz'},
  {id: CallToAction.DriveTraffic, localeLabelKey: 'Drive traffic'},
  {id: CallToAction.GrowList, localeLabelKey: 'Grow list'},
  {id: CallToAction.ScheduleDemo, localeLabelKey: 'Schedule demo'},
  {id: CallToAction.GetDownload, localeLabelKey: 'Get downloads'},
  {id: CUSTOM_GOAL_VALUE, localeLabelKey: 'Other'},
];

export function isCustomGoal(
  value: CallToAction | string | null | undefined
): value is string {
  return (
    typeof value === 'string' &&
    !Object.values(CallToAction).includes(value as CallToAction)
  );
}
